import React from 'react';
import { BoxContent } from '@mm/components';
import { ReactComponent as InvalidInviteIcon } from 'assets/icons/invalid-invite.svg';
import './InviteErrorPage.pcss';

const InviteErrorPage = () => {
  return (
    <BoxContent className="invalid-invite__content">
      <InvalidInviteIcon />
      <div className="invalid-invite__content-header">Invite link broken</div>
      <div className="invalid-invite__content-text">
        The invite link you used is invalid.
      </div>
      <div className="invalid-invite__content-text">
        <strong>Contact the person who sent it to you.</strong>
      </div>
    </BoxContent>
  );
};
export default InviteErrorPage;
